// Pure helpers for the "Link to Airbo" tokens in broadcast bodies, shared by
// Email.jsx, Sms.jsx, Review.jsx and useSmsPreview.js so they all agree on
// what counts as a link token:
//
//   {{link_to_airbo}}       the primary link: the broadcast's campaignUuid,
//                           or the board homepage when that is null.
//   {{link_to_airbo:REF}}   an extra highlight link. REF is a campaign uuid
//                           (what the editor inserts) or a numeric campaign
//                           id (what the MCP/AI tools write).

export const PRIMARY_AIRBO_LINK_TOKEN = '{{link_to_airbo}}';

// Global regexes are only ever used with String#replace (which resets
// lastIndex) so their state can't leak between calls.
const ANY_AIRBO_LINK = /\{\{link_to_airbo(?::[\w-]+)?\}\}/g;
const EXTRA_AIRBO_LINK = /\{\{link_to_airbo:[\w-]+\}\}/g;

// TinyMCE `noneditable_regexp`: keeps every {{snake_case}} token (first_name,
// employee_id, recipient fields, link_to_airbo) as one uneditable chip, and
// lets it carry a `:REF` suffix. Pass it to TinyMCE only; it is global, so
// don't call `.test()` on it.
export const NONEDITABLE_TOKEN_REGEXP = /{{[a-z][a-z0-9_]*(?::[\w-]+)?}}/g;

export const extraAirboLinkToken = ref => `{{link_to_airbo:${ref}}}`;

// Swaps the primary token and every extra token for the same replacement.
export const replaceAirboLinkTokens = (text, replacement) =>
  (text ?? '').replace(ANY_AIRBO_LINK, () => replacement);

// Turns every extra token into the primary token, so a body with several
// links can be handled as if they were all the same "click here" link.
export const normalizeExtraAirboLinks = text =>
  (text ?? '').replace(EXTRA_AIRBO_LINK, PRIMARY_AIRBO_LINK_TOKEN);

export const hasPrimaryAirboLink = text =>
  (text ?? '').includes(PRIMARY_AIRBO_LINK_TOKEN);
